<div class="achievement-notification" [ngClass]="{'bg-primary':activeAchievement.type !== 'week-streak', 'bg-light':activeAchievement.type === 'week-streak'}">
  

    <div class="achievement-wrap">
      <a class="close-btn" (click)="onCloseAward($event)">
        <span class="icon-wrap back-link">
          <fa-icon [icon]="['far', 'arrow-alt-left']"></fa-icon> </span
      ></a>
      <div>
        <h1>{{ 'CONGRATULATIONS' | translate }}!</h1>
        <h2>{{ 'YOU JUST EARNED A NEW BADGE' | translate }}</h2>
        <app-achievements-badge
          [achievement]="activeAchievement"
        ></app-achievements-badge>
        
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'prepFit'">Prep Fit Workouts Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'prepSteps'">Prep Steps Workouts Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'prepStrong'">Prep Strong Workouts Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'breatheWell'">Breathe Well Workouts Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'eatWell'">Eat Well Entries Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'feelWell'">Feel Well Entries Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'sleepWell'">Sleep Well Entries Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'drinkGuide'">Drinking Guide Entries Milestone</h3>
        <h3 *ngIf="activeAchievement.type === 'badge-total' && activeAchievement.area === 'iQuit'">I Quit Entries Milestone</h3>

        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'prepWell' ">Weekly Achievement</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'prepFit'">Prep Fit Workouts Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'prepSteps'">Prep Steps Workouts Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'prepStrong'">Prep Strong Workouts Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'breatheWell'">Breathe Well Workouts Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'eatWell'">Eat Well Entries Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'feelWell'">Feel Well Entries Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'sleepWell'">Sleep Well Entries Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'drinkGuide'">Drinking Guide Entries Week Streak</h3>
        <h3 *ngIf="activeAchievement.type === 'week-streak' && activeAchievement.area === 'iQuit'">I Quit Entries Week Streak</h3>
  
       
  
        <a [routerLink]="['/programme','achievements']" class="btn btn-rounded btn-dark w-100 mt-4 mb-2" (click)="onCloseAward($event)">{{ 'View Achievements' | uppercase | translate }}</a>
      </div>
    </div>
  </div>
  